/**
 * Rethrows the error if it is not in the list of excluded status codes.
 * Meant to be used by code that uses axios to make API calls so expected
 * error codes do not trigger sentry alerts. Toast messages are still shown.
 *
 * TODO: move this into backend-api.ts once it has been converted to typescript.
 *
 * @param error The error object to check.
 * @param excludes The status code or codes to exclude. i.e. 404 or [404, 409]
 */
export function filterAlerts(error: any, excludes: number | number[]) {
  if (error?.response && ![].concat(excludes).includes(error.response.status)) {
    throw error;
  }
}
